import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs';
import { LoaderService } from '../../services/loader.service';

@Component({
    selector: 'app-progress-bar',
    templateUrl: './progress-bar.component.html',
    styleUrls: ['./progress-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProgressBarComponent implements OnInit {

  isProgressing: Subject<boolean> = this.loaderService.isProgressing;

  constructor(private readonly loaderService: LoaderService) { }

  ngOnInit() {
    this.loaderService.showProgressBar();
  }

}
